import React from "react";
import { getString } from "../../utilities";
import SubscriptionCard from "./subscriptionCard";
import { getLangCode, language } from "../../config";
import PlanPerks from "./PlanPerks";
import routeCodes from "../../config/routeCodes";
import Arrow from "../../../assets/svg/arrowRight.svg";

export default function ClassroomPlans({
  plan,
  setPlan,
  planAmount,
  setPlanAmount,
  planData,
  activeClick,
  handleNavigate,
  className,
}) {
  const langCode = getLangCode();

  return (
    <div className="subscribe-plans-wrapper">
      <div className={`${className} transition-count-1`}>
        <h2>
          {getString(
            langCode === language.la ? "subscribe.plans.classroom.title.2" : "subscribe.plans.classroom.title.5",
          )}
        </h2>

        <PlanPerks devices={getString("subscribe.plans.perks.devices.classroom")} />
      </div>

      <div className={`${className} transition-count-2`}>
        <div className="subscribe-plans-container">
          <SubscriptionCard
            setPlan={setPlan}
            planAmount={planAmount}
            setPlanAmount={setPlanAmount}
            planData={planData}
            plan={plan}
            subscription="m12"
            tabIndex={0}
            activeClick={activeClick}
          />
        </div>

        <div className="subscribe-plans-description">{getString("subscribe.plans.description")}</div>

        {getLangCode() === language.default && (
          <div className="subscribe-cta-links-container">
            <p>{getString("subscribe.plans.school.want")}</p>

            <button
              data-testid="schoolSubCtaPurchase"
              type="button"
              role="button"
              aria-label={getString("subscribe.plans.school.go")}
              onClick={() => {
                if (handleNavigate) {
                  handleNavigate(routeCodes.SUBSCRIBE_SCHOOL);
                }
              }}
              className="planbutton button-flat-color pt-cyan round auto"
            >
              {getString("subscribe.plans.school.purchase")}
              <Arrow className="inline-arrow" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
